export const PHASE1_SERVICE_SLUGS = [
  "transport-de-meubles", "petit-demenagement", "camion-avec-chauffeur",
  "transport-electromenager", "livraison-leboncoin-marketplace", "debarras",
  "transport-longue-distance", "groupage-transport",
];

const RAW_MAIN_SERVICES = [
  {
    slug: "transport-de-meubles",
    label: "Transport de meubles",
    h1: "Transport de meubles",
    metaTitle: "Transport de meubles — Express Delivery",
    metaDescription: "Transport de meubles avec camion et chauffeur : canapé, lit, armoire, table. Devis clair et rapide au Havre et en Normandie.",
    intro: "Canapé, lit, armoire, table ou meuble volumineux : Express Delivery transporte vos meubles avec soin, dans un camion avec chauffeur adapté au volume et à la distance.",
    localTypeKey: "meuble",
  },
  {
    slug: "petit-demenagement",
    label: "Déménagement",
    h1: "Déménagement",
    metaTitle: "Déménagement — Express Delivery",
    metaDescription: "Déménagement studio, T1, T2 avec camion et chauffeur. Aide à la manutention possible. Devis clair avant intervention.",
    intro: "Studio, chambre, T1/T2 ou chargement partiel : Express Delivery organise votre déménagement avec un camion adapté et une aide à la manutention possible.",
    localTypeKey: "petit-demenagement",
  },
  {
    slug: "camion-avec-chauffeur",
    label: "Camion avec chauffeur",
    h1: "Camion avec chauffeur",
    metaTitle: "Camion avec chauffeur — Express Delivery",
    metaDescription: "Un camion grand volume avec chauffeur pour vos transports locaux ou longue distance. Aide possible selon le besoin.",
    intro: "Un camion grand volume avec chauffeur pour un transport simple, local ou longue distance. Une aide à la manutention peut être prévue selon le besoin.",
    localTypeKey: "camion-avec-chauffeur",
  },
  {
    slug: "transport-electromenager",
    label: "Transport électroménager",
    h1: "Transport électroménager",
    metaTitle: "Transport électroménager — Express Delivery",
    metaDescription: "Transport de machine à laver, frigo, sèche-linge ou électroménager volumineux avec attention et camion adapté.",
    intro: "Machine à laver, frigo, sèche-linge ou électroménager volumineux transporté avec attention, dans un camion avec chauffeur adapté.",
    localTypeKey: "electromenager",
  },
  {
    slug: "livraison-leboncoin-marketplace",
    label: "Livraison Leboncoin / Marketplace",
    h1: "Livraison Leboncoin / Marketplace",
    metaTitle: "Livraison Leboncoin / Marketplace — Express Delivery",
    metaDescription: "Récupération et livraison d'objets volumineux achetés entre particuliers sur Leboncoin ou Marketplace.",
    intro: "Récupération et livraison d'objets volumineux achetés entre particuliers sur Leboncoin ou Facebook Marketplace, avec aide au portage possible.",
    localTypeKey: "livraison-leboncoin",
  },
  {
    slug: "debarras",
    label: "Débarras",
    h1: "Débarras",
    metaTitle: "Débarras — Express Delivery",
    metaDescription: "Débarras de meubles, encombrants ou volumes à évacuer selon l'accès et la quantité. Devis clair avant intervention.",
    intro: "Évacuation de meubles, encombrants ou volumes à débarrasser selon l'accès et la quantité à traiter.",
    localTypeKey: "debarras",
  },
  {
    slug: "aide-manutention",
    label: "Aide à la manutention",
    h1: "Aide à la manutention",
    metaTitle: "Aide à la manutention — Express Delivery",
    metaDescription: "Aide au chargement, déchargement et manipulation des objets volumineux selon vos besoins.",
    intro: "Aide possible pour charger, décharger et manipuler les objets volumineux, selon les accès, les étages et le volume à transporter.",
    localTypeKey: null,
  },
  {
    slug: "transport-longue-distance",
    label: "Transport longue distance",
    h1: "Transport longue distance",
    metaTitle: "Transport longue distance — Express Delivery",
    metaDescription: "Transport longue distance depuis la Normandie vers d'autres régions françaises. Groupage possible selon disponibilité.",
    intro: "Depuis Le Havre et la Normandie, Express Delivery organise des transports longue distance vers d'autres régions. Les trajets sont optimisés à l'aller comme au retour lorsque cela est possible.",
    localTypeKey: null,
  },
  {
    slug: "groupage-transport",
    label: "Groupage transport",
    h1: "Groupage transport",
    metaTitle: "Groupage transport — Express Delivery",
    metaDescription: "Le groupage permet d'optimiser les trajets et de proposer un tarif plus avantageux lorsque plusieurs transports sont compatibles.",
    intro: "Le groupage permet d'optimiser les trajets et de proposer un tarif plus avantageux lorsque plusieurs transports sont compatibles sur un même trajet.",
    localTypeKey: null,
  },
  {
    slug: "transport-entreprise",
    label: "Transport entreprise",
    h1: "Transport pour entreprises",
    metaTitle: "Transport entreprise — Express Delivery",
    metaDescription: "Transport ponctuel ou régulier pour professionnels : livraison volumineuse, manutention, facture, créneaux planifiés.",
    intro: "Express Delivery accompagne les professionnels pour leurs besoins de transport ponctuel ou régulier : livraison volumineuse, manutention, débarras, facture et créneaux planifiés.",
    localTypeKey: null,
  },
  {
    slug: "transport-institution",
    label: "Transport institution",
    h1: "Transport pour institutions",
    metaTitle: "Transport institution — Express Delivery",
    metaDescription: "Intervention organisée et devis formel pour collectivités, associations et organismes, avec coordination d'un référent.",
    intro: "Express Delivery peut établir un devis formel et organiser une intervention structurée pour collectivités, associations, bailleurs et organismes, avec coordination d'un référent.",
    localTypeKey: null,
  },
];

export const MAIN_SERVICES = RAW_MAIN_SERVICES.map((s) => ({
  ...s,
  isPhase1: PHASE1_SERVICE_SLUGS.includes(s.slug),
}));

export function getMainServiceBySlug(slug) {
  return MAIN_SERVICES.find((s) => s.slug === slug);
}

export function getPhase1MainServices() {
  return MAIN_SERVICES.filter((s) => s.isPhase1);
}
